// extracted by mini-css-extract-plugin
export default {"container":"StatusIndicator-module__container--4Zc5d"};